import React from "react";
import Contactbanner from "../Mencontactus/Contactbanner";
import Bredcrumb from "../Bredcrumb/Main";
import Img from "../../assets/images/background/banner-image-4.jpg";
import usePagePhotos from "../../hooks/usePagePhotos";

function Main() {
  const { getPhoto } = usePagePhotos('contact');

  // Get banner image from CMS or use hardcoded fallback
  const bannerImgPhoto = getPhoto('banner_image');
  const bannerImg = (bannerImgPhoto && bannerImgPhoto.url) ? bannerImgPhoto.url : Img;

  return (
    <>
      <Bredcrumb title="ANY QUERY ?" subtitle="Contact Us" Img={bannerImg} />

      <Contactbanner />
    </>
  );
}

export default Main;
